import type { HandledWorkspace } from 'state/forms/models';
import { QuotePriceEvent, RemainingValues } from 'utils/streaming/quotePriceEvent';
export type StreamingPriceActions =
  | StreamingPriceReceived
  | StreamingQuoteClosed
  | StreamingQuoteRejected
  | StreamingQuoteExpired;

export function streamingPriceReceived(tabId: string, price: QuotePriceEvent<RemainingValues>) {
  return { ...price, tabId, type: 'STREAMING_PRICE_RECEIVED' as const };
}
export type StreamingPriceReceived = ReturnType<typeof streamingPriceReceived>;

export function streamingQuoteClosed(tabId: string, quoteId: string, workspace: HandledWorkspace) {
  return {
    type: 'STREAMING_QUOTE_CLOSED' as const,
    tabId,
    quoteId,
    workspace,
  };
}
export type StreamingQuoteClosed = ReturnType<typeof streamingQuoteClosed>;

export function streamingQuoteExpired(tabId: string, quoteId: string, workspace: HandledWorkspace) {
  return {
    ...streamingQuoteClosed(tabId, quoteId, workspace),
    type: 'STREAMING_QUOTE_EXPIRED' as const,
  };
}
export type StreamingQuoteExpired = ReturnType<typeof streamingQuoteExpired>;

export function streamingQuoteRejected(tabId: string, quoteId: string, error?: string) {
  return {
    type: 'STREAMING_QUOTE_REJECTED' as const,
    quoteId,
    tabId,
    error,
  };
}
export type StreamingQuoteRejected = ReturnType<typeof streamingQuoteRejected>;
